import React from "react";
import {
    Container,
    Row,
    Col,
    Input,
    Form,
    FormGroup
} from "reactstrap";
import { useTwoFactorVerification } from "./hooks/use-two-factor-verification";
import LoadingButton from "@components/ui-components/loading-button";
import Card from "@src/@core/components/ui-components/card";

import { useTranslation } from "react-i18next";

export const TwoFactorAuth = () => {
    const {
        handleResend,
        handlePaste,
        handleKeyDown,
        submitCode,
        handleChange,
        values,
        inputsRef,
        cooldown,
        verifyLoading,
        resendLoading
    } = useTwoFactorVerification();
    const { t } = useTranslation();

    return (
        <Container className="mt-5">
            <Row className="justify-content-center">
                <Col xs="12" md="8" lg="6">
                    <Card
                        containerClass="overflow-hidden border-1 rounded-4 shadow-sm"
                        bodyClass="p-4">
                        <div className="d-flex align-items-start">
                            <div>
                                <h4 className="mb-1 fw-bold">
                                    {t("For your account’s protection, we use two-factor authentication to keep your data secure.")}
                                </h4>
                                <p className="text-muted mb-3">
                                    {t("Please enter the 6-digit verification code sent to your email. The OTP will expire in 5 minutes.")}
                                </p>
                            </div>
                        </div>

                        <Form>
                            <FormGroup className="d-flex gap-2 justify-content-center mb-3">
                                {values.map((val, i) => (
                                    <Input
                                        key={i}
                                        innerRef={(el) => (inputsRef.current[i] = el)}
                                        value={val}
                                        onChange={(e) => handleChange(i, e.target.value)}
                                        onKeyDown={(e) => handleKeyDown(e, i)}
                                        onPaste={handlePaste}
                                        type="text"
                                        maxLength={1}
                                        className="text-center"
                                        aria-label={t(`Digit ${i + 1}`)}
                                        autoComplete="one-time-code"/>
                                ))}
                            </FormGroup>

                            <div className="d-flex align-items-center justify-content-between gap-2">
                                <LoadingButton
                                    testId="verify"
                                    color="primary"
                                    text="Verify"
                                    loading = {verifyLoading}
                                    onClick={submitCode}/>

                                <div className="text-end">
                                    <div className="mb-25 fs-6 text-muted">
                                        {t("Didn’t receive it?")}
                                    </div>
                                    <div>
                                        <LoadingButton
                                            testId="resend"
                                            color="link"
                                            text={ cooldown > 0 ? `Resend in ${cooldown}s` : "Resend OTP" }
                                            className="text-decoration-none py-0"
                                            loading={resendLoading}
                                            onClick={handleResend}
                                            disabled={cooldown > 0 || resendLoading}/>
                                    </div>
                                </div>
                            </div>
                          
                            <div className="mt-4 text-center">
                                <small className="text-muted">
                                    {t("By continuing you agree to the platform terms. If you didn’t request this, please secure your account.")}
                                </small>
                            </div>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default TwoFactorAuth;
